import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    display: none;

    @media (max-width: 768px) {
        display: block;
    }
`

export const Imagem = styled.img`
    float: left;
    width: 100%;
`